// reducer.js
import {
  RETURN_PARSED_RESUME_REQUEST,
  RETURN_PARSED_RESUME_SUCCESS,
  RETURN_PARSED_RESUME_FAILURE,
  RETURN_PARSED_RESUME_RESET,
} from "../../actionTypes";

const initialState = {
  isLoading: false,
  status: false,
  data: "",
  message: "",
};

const returnParseResumeReducer = (state = initialState, action) => {
  switch (action.type) {
    case RETURN_PARSED_RESUME_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case RETURN_PARSED_RESUME_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
        data: action.payload.parsed_resumes,
      };
    case RETURN_PARSED_RESUME_FAILURE:
      return {
        ...state,
        isLoading: false,
        message: action.payload.message,
        status: action.payload.status,
      };
    case RETURN_PARSED_RESUME_RESET:
      return {
        ...state,
        isLoading: false,
        status: false,
        message: "",
      };
    default:
      return state;
  }
};

export default returnParseResumeReducer;
